(function () {
  'use strict';

  if (window.__ciaVideoStoriesInit) return;
  window.__ciaVideoStoriesInit = true;

  var COLOR_MAP = {
    'azul noite': '#1A1A4E',
    'rosa suave': '#FFD4E8',
    'bege': '#FCEED4',
    'cinza': '#656362',
    'vinho': '#6B1A2A'
  };

  var SIZE_ORDER = ['PP', 'P', 'M', 'G', 'GG', 'XGG'];

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function unique(values) {
    var seen = new Set();
    var out = [];
    values.forEach(function (val) {
      var key = normalize(val);
      if (!key || seen.has(key)) return;
      seen.add(key);
      out.push(val);
    });
    return out;
  }

  function parseJsonScript(el) {
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncateTitle(value, maxLength) {
    var source = String(value || '').trim();
    var limit = Math.max(1, parseInt(maxLength || 30, 10) || 30);
    if (source.length <= limit) return source;
    return source.slice(0, Math.max(0, limit - 3)).trim() + '...';
  }

  function normalizeMetaobjectType(type) {
    return String(type || 'storiesVideos').trim() || 'storiesVideos';
  }

  function extractNumericId(value) {
    var source = String(value || '');
    var match = source.match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function getFieldByKeys(fields, keys) {
    if (!Array.isArray(fields)) return null;
    var wanted = keys.map(normalize);
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (wanted.indexOf(normalize(field && field.key)) !== -1) {
        return field;
      }
    }
    return null;
  }

  function getFieldReferences(field) {
    if (!field) return [];
    if (field.references && Array.isArray(field.references.nodes)) {
      return field.references.nodes;
    }
    if (field.reference) {
      return [field.reference];
    }
    return [];
  }

  function getVideoUrlFromReference(ref) {
    if (!ref) return '';
    if (ref.__typename === 'Video' && Array.isArray(ref.sources) && ref.sources.length) {
      var mp4 = ref.sources.find(function (source) {
        return source && source.mimeType && source.mimeType.indexOf('video/') === 0;
      });
      return (mp4 && mp4.url) || (ref.sources[0] && ref.sources[0].url) || '';
    }
    if (ref.__typename === 'GenericFile') {
      return ref.url || '';
    }
    return '';
  }

  function getVideoThumbFromReference(ref) {
    if (!ref) return '';
    if (ref.__typename === 'Video' && ref.previewImage && ref.previewImage.url) {
      return ref.previewImage.url;
    }
    if (ref.__typename === 'GenericFile' && ref.previewImage && ref.previewImage.url) {
      return ref.previewImage.url;
    }
    return '';
  }

  function mapProductReference(ref) {
    if (!ref || ref.__typename !== 'Product') return null;
    var variantNodes = [];
    if (ref.variants && Array.isArray(ref.variants.nodes)) {
      variantNodes = ref.variants.nodes;
    } else if (Array.isArray(ref.variants)) {
      variantNodes = ref.variants;
    }

    return {
      id: ref.id || 0,
      handle: ref.handle || '',
      url: ref.onlineStoreUrl || (ref.handle ? '/products/' + ref.handle : ''),
      title: ref.title || '',
      featuredImage: ref.featuredImage && ref.featuredImage.url ? ref.featuredImage.url : '',
      price: ref.priceRange && ref.priceRange.minVariantPrice ? Number(ref.priceRange.minVariantPrice.amount || 0) * 100 : 0,
      variants: variantNodes,
      options: Array.isArray(ref.options) ? ref.options : []
    };
  }

  function parseVariantCtaValue(field) {
    if (!field || !field.value) return '';
    var raw = String(field.value || '').trim();
    if (!raw) return '';
    try {
      var parsed = JSON.parse(raw);
      if (typeof parsed === 'string') return parsed;
      if (parsed && typeof parsed === 'object') {
        return String(parsed.text || parsed.label || parsed.cta || '');
      }
    } catch (err) {
      return raw;
    }
    return raw;
  }

  function mapMetaobjectNodeToStories(node) {
    var fields = Array.isArray(node && node.fields) ? node.fields : [];
    var productField = getFieldByKeys(fields, ['produtos', 'products', 'produto', 'product']);
    var videosField = getFieldByKeys(fields, ['videos', 'video']);
    var variantCtaField = getFieldByKeys(fields, ['variantcta', 'variant_cta', 'variantCta']);
    var titleField = getFieldByKeys(fields, ['titulo', 'title']);
    var labelField = getFieldByKeys(fields, ['label', 'etiqueta']);

    var products = getFieldReferences(productField)
      .map(mapProductReference)
      .filter(Boolean);

    var videoRefs = getFieldReferences(videosField).map(function (ref) {
      return {
        url: getVideoUrlFromReference(ref),
        thumb: getVideoThumbFromReference(ref)
      };
    }).filter(function (item) {
      return !!item.url;
    });

    if (!videoRefs.length && videosField && videosField.value) {
      videoRefs = [{ url: String(videosField.value), thumb: '' }];
    }

    var variantCtaText = parseVariantCtaValue(variantCtaField);
    var title = (titleField && titleField.value) || (products[0] && products[0].title) || 'Story';
    var label = (labelField && labelField.value) || '';

    var stories = [];
    var total = Math.max(videoRefs.length, products.length, 0);
    for (var i = 0; i < total; i += 1) {
      var videoData = videoRefs[i] || videoRefs[0] || null;
      if (!videoData || !videoData.url) continue;
      var product = products[i] || products[0] || null;

      stories.push({
        index: 0,
        videoUrl: videoData.url,
        thumbnail: videoData.thumb || (product && product.featuredImage) || '',
        title: title,
        label: label,
        variantCTA: variantCtaText,
        product: product || {
          id: 0,
          handle: '',
          url: '',
          title: '',
          featuredImage: '',
          price: 0,
          variants: [],
          options: []
        }
      });
    }

    return stories;
  }

  async function fetchStoriesFromMetaobject(config) {
    var token = String(config.storefrontToken || '').trim();
    var apiVersion = String(config.storefrontApiVersion || '2024-01').trim();
    var type = normalizeMetaobjectType(config.metaobjectType);
    var first = Math.max(1, parseInt(config.metaobjectLimit || 20, 10) || 20);

    if (!token) return [];

    var query = 'query GetStoriesVideos($type: String!, $first: Int!) { metaobjects(type: $type, first: $first) { edges { node { id handle fields { key value reference { __typename ... on Product { id title handle onlineStoreUrl featuredImage { url } priceRange { minVariantPrice { amount } } options { name values } variants(first: 50) { nodes { id title availableForSale selectedOptions { name value } price { amount } } } } ... on Video { sources { url mimeType } previewImage { url } } ... on GenericFile { url previewImage { url } } } references(first: 50) { nodes { __typename ... on Product { id title handle onlineStoreUrl featuredImage { url } priceRange { minVariantPrice { amount } } options { name values } variants(first: 50) { nodes { id title availableForSale selectedOptions { name value } price { amount } } } } ... on Video { sources { url mimeType } previewImage { url } } ... on GenericFile { url previewImage { url } } } } } } } } }';

    var payload = {
      query: query,
      variables: {
        type: type,
        first: first
      }
    };

    try {
      var response = await fetch('/api/' + apiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) return [];
      var result = await response.json();
      if (!result || result.errors || !result.data || !result.data.metaobjects) {
        return [];
      }

      var edges = Array.isArray(result.data.metaobjects.edges) ? result.data.metaobjects.edges : [];
      var stories = [];
      edges.forEach(function (edge) {
        var nodeStories = mapMetaobjectNodeToStories(edge && edge.node ? edge.node : {});
        stories = stories.concat(nodeStories);
      });

      return stories.map(function (story, idx) {
        story.index = idx;
        return story;
      });
    } catch (err) {
      return [];
    }
  }

  function normalizeVariantShape(product) {
    if (!product || !Array.isArray(product.variants)) return product;

    product.variants = product.variants.map(function (variant) {
      if (!variant) return variant;

      if (variant.selectedOptions && !variant.option1) {
        var selected = Array.isArray(variant.selectedOptions) ? variant.selectedOptions : [];
        selected.forEach(function (opt, idx) {
          var index = idx + 1;
          variant['option' + index] = opt && opt.value ? opt.value : '';
        });
      }

      if (variant.price && typeof variant.price === 'object' && variant.price.amount !== undefined) {
        variant.price = Math.round(Number(variant.price.amount || 0) * 100);
      }

      if (variant.availableForSale !== undefined && variant.available === undefined) {
        variant.available = !!variant.availableForSale;
      }

      if (typeof variant.id === 'string') {
        var idMatch = variant.id.match(/(\d+)$/);
        if (idMatch) {
          variant.id = parseInt(idMatch[1], 10);
        }
      }

      return variant;
    });

    if (Array.isArray(product.options) && product.options.length && typeof product.options[0] === 'object') {
      product.options = product.options.map(function (opt) {
        return opt && opt.name ? opt.name : String(opt || '');
      });
    }

    return product;
  }

  function filterStoriesForCurrentProduct(stories, config) {
    var shouldFilter = !!(config && config.filterByCurrentProduct);
    if (!shouldFilter) {
      return stories;
    }

    var currentHandle = normalize(config.currentProductHandle || '');
    var currentId = extractNumericId(config.currentProductId);

    return stories.filter(function (story) {
      if (!story || !story.product) return false;

      var storyHandle = normalize(story.product.handle || '');
      if (currentHandle && storyHandle && currentHandle === storyHandle) {
        return true;
      }

      var storyId = extractNumericId(story.product.id);
      if (currentId && storyId && currentId === storyId) {
        return true;
      }

      return false;
    });
  }

  function renderStoriesIntoWidget(widget, stories) {
    var strip = widget.querySelector('[data-vs-strip]');
    if (!strip) return;

    strip.innerHTML = '';
    stories.forEach(function (story, index) {
      var title = story.title || (story.product && story.product.title) || 'Story';
      var thumb = story.thumbnail || (story.product && story.product.featuredImage) || '';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vs-thumb';
      button.setAttribute('data-vs-thumb', '');
      button.setAttribute('data-story-index', String(index));
      button.setAttribute('aria-label', 'Abrir story ' + escapeHtml(title));
      button.innerHTML = '<div class="vs-thumb-media">'
        + '<video class="vs-thumb-video" data-vs-lazy-video data-src="' + escapeHtml(story.videoUrl || '') + '"'
        + (thumb ? ' poster="' + escapeHtml(thumb) + '"' : '')
        + ' muted loop playsinline preload="none" aria-hidden="true"></video>'
        + '<span class="vs-play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v13.72c0 .78.85 1.26 1.52.87l10.7-6.86a1 1 0 000-1.72L9.52 4.27A1 1 0 008 5.14z"/></svg></span>'
        + '</div>';
      strip.appendChild(button);

      var script = document.createElement('script');
      script.type = 'application/json';
      script.setAttribute('data-vs-story-json', String(index));
      script.textContent = JSON.stringify(story);
      strip.appendChild(script);
    });
  }

  function openCartDrawerFromTheme() {
    var cartToggle = document.getElementById('cart-toggle');
    if (cartToggle) {
      cartToggle.click();
      return;
    }

    var cartDrawer = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-overlay');
    if (!cartDrawer) return;

    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) {
      cartOverlay.classList.add('open');
      cartOverlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function getStoryData(widget) {
    var scripts = widget.querySelectorAll('[data-vs-story-json]');
    var stories = [];
    scripts.forEach(function (script) {
      var data = parseJsonScript(script);
      if (!data || !data.videoUrl) return;
      stories.push(data);
    });
    return stories;
  }

  function buildSegments(progressEl, count) {
    progressEl.innerHTML = '';
    for (var i = 0; i < count; i += 1) {
      var seg = document.createElement('div');
      seg.className = 'vs-progress-segment';
      var bar = document.createElement('div');
      bar.className = 'vs-progress-bar';
      seg.appendChild(bar);
      progressEl.appendChild(seg);
    }
  }

  function setSegment(progressEl, index, ratio) {
    var bars = progressEl.querySelectorAll('.vs-progress-bar');
    bars.forEach(function (bar, i) {
      if (i < index) {
        bar.style.width = '100%';
      } else if (i > index) {
        bar.style.width = '0%';
      } else {
        var pct = Math.max(0, Math.min(1, ratio)) * 100;
        bar.style.width = pct + '%';
      }
    });
  }

  function findOptionIndex(product, names) {
    if (!product || !Array.isArray(product.options)) return -1;
    var normalizedNames = names.map(normalize);
    for (var i = 0; i < product.options.length; i += 1) {
      if (normalizedNames.indexOf(normalize(product.options[i])) !== -1) {
        return i;
      }
    }
    return -1;
  }

  function getVariantValue(variant, index) {
    if (!variant || index < 0) return '';
    var values = [variant.option1, variant.option2, variant.option3];
    return values[index] || '';
  }

  function getStoryCompareAtPrice(product, basePrice) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return 0;

    var highestCompare = 0;
    product.variants.forEach(function (variant) {
      if (!variant || !variant.available) return;
      var compare = Number(variant.compare_at_price || variant.compareAtPrice || 0);
      var price = Number(variant.price || basePrice || 0);
      if (compare > price && compare > highestCompare) {
        highestCompare = compare;
      }
    });

    return highestCompare;
  }

  function createSwatchButton(color) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vs-swatch';
    var dot = document.createElement('span');
    dot.className = 'vs-swatch-dot';
    dot.style.background = COLOR_MAP[normalize(color)] || '#656362';
    btn.appendChild(dot);
    btn.appendChild(document.createTextNode(color));
    btn.dataset.value = color;
    return btn;
  }

  function createSizeButton(size) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vs-size-pill';
    btn.textContent = size;
    btn.dataset.value = size;
    return btn;
  }

  function getLowQualityPreviewCandidates(url) {
    var source = String(url || '').trim();
    if (!source) return [];

    var candidates = [];
    var isShopifyCdn = source.indexOf('cdn.shopify.com') !== -1;
    var mp4Match = source.match(/\.mp4(?:\?|$)/i);

    if (isShopifyCdn && mp4Match) {
      candidates.push(source.replace(/\.mp4(\?|$)/i, '_360p.mp4$1'));
      candidates.push(source.replace(/\.mp4(\?|$)/i, '_480p.mp4$1'));
    }

    candidates.push(source);

    return candidates.filter(function (item, index, arr) {
      return item && arr.indexOf(item) === index;
    });
  }

  function initLazyThumbVideos(widget) {
    var videos = widget.querySelectorAll('[data-vs-lazy-video]');
    if (!videos.length) {
      return {
        pauseAll: function () {},
        resumeVisible: function () {}
      };
    }

    var firstVideo = videos[0] || null;
    var currentPlaying = null;

    function setLowBandwidthMode(video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.disablePictureInPicture = true;
      video.playbackRate = 0.85;
      video.defaultPlaybackRate = 0.85;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
    }

    function ensurePreviewSource(video) {
      if (video.dataset.vsLoaded === 'true') return;
      var source = video.dataset.src;
      if (!source) return;

      var candidates = getLowQualityPreviewCandidates(source);
      if (!candidates.length) return;

      video.dataset.vsLoaded = 'true';
      video.dataset.vsPreviewSrc = candidates[0];
      video.dataset.vsFullSrc = source;

      var candidateIndex = 0;
      function loadCandidate() {
        if (candidateIndex >= candidates.length) return;
        video.src = candidates[candidateIndex];
        video.load();
      }

      video.addEventListener('error', function onPreviewError() {
        candidateIndex += 1;
        if (candidateIndex >= candidates.length) {
          video.removeEventListener('error', onPreviewError);
          return;
        }
        loadCandidate();
      });

      loadCandidate();
    }

    function pauseVideo(video) {
      if (!video) return;
      try {
        video.pause();
      } catch (err) {
        return;
      }
      if (currentPlaying === video) currentPlaying = null;
    }

    function playVideo(video) {
      if (!video || video.dataset.vsBlocked === 'true') return;
      setLowBandwidthMode(video);
      ensurePreviewSource(video);

      if (currentPlaying && currentPlaying !== video) {
        pauseVideo(currentPlaying);
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      currentPlaying = video;
    }

    function pauseAll(block) {
      videos.forEach(function (video) {
        if (block) video.dataset.vsBlocked = 'true';
        pauseVideo(video);
      });
    }

    function resumeVisible() {
      videos.forEach(function (video) {
        video.dataset.vsBlocked = 'false';
      });
      if (!firstVideo) return;
      playVideo(firstVideo);
    }

    videos.forEach(function (video, index) {
      setLowBandwidthMode(video);
      if (index === 0) {
        ensurePreviewSource(video);
      }
    });

    if (firstVideo) {
      playVideo(firstVideo);
    }

    return {
      pauseAll: pauseAll,
      resumeVisible: resumeVisible
    };
  }

  function extractVideoFileName(url) {
    var source = String(url || '').trim();
    if (!source) return '';
    var withoutQuery = source.split('?')[0];
    var parts = withoutQuery.split('/');
    return parts[parts.length - 1].toLowerCase();
  }

  function deduplicateStoriesByFileName(stories) {
    var seen = new Set();
    return stories.filter(function (story) {
      var key = extractVideoFileName(story && story.videoUrl);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  async function initWidget(widget) {
    if (widget.dataset.vsReady === 'true') return;
    widget.dataset.vsReady = 'true';

    var configEl = widget.querySelector('[data-vs-config]');
    var config = parseJsonScript(configEl) || {};
    var stories = deduplicateStoriesByFileName(getStoryData(widget));

    var sourceMode = normalize((config && config.dataSource) || 'auto');
    var shouldUseMetaobject = sourceMode === 'auto' || sourceMode === 'metaobject';
    if (shouldUseMetaobject) {
      var remoteStories = await fetchStoriesFromMetaobject(config || {});
      remoteStories = filterStoriesForCurrentProduct(remoteStories, config || {});
      remoteStories = deduplicateStoriesByFileName(remoteStories);

      if (remoteStories.length) {
        remoteStories.forEach(function (story) {
          if (story && story.product) {
            normalizeVariantShape(story.product);
          }
        });
        renderStoriesIntoWidget(widget, remoteStories);
        stories = remoteStories;
      } else if (sourceMode === 'metaobject') {
        stories = [];
      }
    }

    if (!stories.length) {
      widget.hidden = true;
      widget.setAttribute('aria-hidden', 'true');
      return;
    }

    var viewer = widget.querySelector('[data-vs-viewer]');
    var mainVideo = widget.querySelector('[data-vs-main-video]');
    var storyTitle = widget.querySelector('[data-vs-story-title]');
    var progressEl = widget.querySelector('[data-vs-progress]');
    var qo = widget.querySelector('[data-vs-quick-order]');
    var qoTitle = widget.querySelector('[data-vs-qo-product-title]');
    var colorWrap = widget.querySelector('[data-vs-color-swatches]');
    var sizeWrap = widget.querySelector('[data-vs-size-pills]');
    var qtyInput = widget.querySelector('[data-vs-qty-input]');
    var errorEl = widget.querySelector('[data-vs-error]');
    var successEl = widget.querySelector('[data-vs-success]');
    var qoImage = widget.querySelector('[data-vs-qo-image]');
    var qoProductName = widget.querySelector('[data-vs-qo-product-name]');
    var qoPrice = widget.querySelector('[data-vs-qo-price]');
    var storyCard = widget.querySelector('[data-vs-story-card]');
    var storyCardLinks = widget.querySelectorAll('[data-vs-story-card-link]');
    var storyCardImage = widget.querySelector('[data-vs-story-card-image]');
    var storyCardPrice = widget.querySelector('[data-vs-story-card-price]');
    var storyCardCompare = widget.querySelector('[data-vs-story-card-compare]');
    var storyCardName = widget.querySelector('[data-vs-story-card-name]');
    var storyCardInstallment = widget.querySelector('[data-vs-story-card-installment]');
    var storyCardDiscount = widget.querySelector('[data-vs-story-card-discount]');
    var soundBtn = widget.querySelector('[data-vs-sound]');

    var state = {
      index: 0,
      timer: null,
      startTs: 0,
      raf: null,
      selectedColor: '',
      selectedSize: '',
      selectedStory: null,
      preloadedVideos: {},
      // O som comeca desligado porque o celular recusa autoplay com audio.
      // O botao liga, e a escolha vale para os stories seguintes.
      soundOn: false
    };

    function clearTimers() {
      if (state.timer) {
        window.clearTimeout(state.timer);
        state.timer = null;
      }
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = null;
      }
    }

    function preloadNext(index) {
      var next = stories[index + 1];
      if (!next || !next.videoUrl || state.preloadedVideos[next.videoUrl]) return;
      var v = document.createElement('video');
      v.preload = 'auto';
      v.src = next.videoUrl;
      v.load();
      state.preloadedVideos[next.videoUrl] = true;
    }

    // A barra segue o tempo do proprio video. O storyDuration so entra como
    // rede quando a duracao ainda nao e conhecida ou e um stream sem fim --
    // antes era sempre um cronometro fixo de 60s, e um video de 8s congelava
    // no ultimo quadro com a barra em 13%.
    function stepProgress(fallbackMs, index) {
      var start = performance.now();
      function tick(now) {
        var duration = mainVideo ? mainVideo.duration : NaN;
        var ratio;
        if (isFinite(duration) && duration > 0) {
          ratio = mainVideo.currentTime / duration;
        } else {
          ratio = (now - start) / fallbackMs;
        }
        setSegment(progressEl, index, ratio);
        if (ratio >= 1) {
          nextStory();
          return;
        }
        state.raf = window.requestAnimationFrame(tick);
      }
      state.raf = window.requestAnimationFrame(tick);
    }

    function applySound() {
      if (mainVideo) mainVideo.muted = !state.soundOn;
      if (!soundBtn) return;
      soundBtn.setAttribute('data-sound', state.soundOn ? 'on' : 'off');
      soundBtn.setAttribute('aria-label', state.soundOn ? 'Desligar o som' : 'Ligar o som');
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        state.soundOn = !state.soundOn;
        applySound();
        if (state.soundOn && mainVideo) {
          var p = mainVideo.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              state.soundOn = false;
              applySound();
              mainVideo.play().catch(function () {});
            });
          }
        }
      });
    }

    if (mainVideo) {
      mainVideo.addEventListener('ended', function () {
        nextStory();
      });
    }

    var thumbPlayback = initLazyThumbVideos(widget);

    function openViewer(index) {
      state.index = Math.max(0, Math.min(index, stories.length - 1));
      thumbPlayback.pauseAll(true);
      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      buildSegments(progressEl, stories.length);
      renderStory();
    }

    function closeViewer() {
      clearTimers();
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
      }
      viewer.hidden = true;
      viewer.setAttribute('aria-hidden', 'true');
      closeQuickOrder();
      document.body.style.overflow = '';
      thumbPlayback.resumeVisible();
    }

    function renderStory() {
      clearTimers();
      var story = stories[state.index];
      if (!story) return;
      state.selectedStory = story;

      refreshStoryCard(story);

      if (storyTitle) {
        // Rotulo curto do bloco; o nome do produto vive na barra de baixo.
        storyTitle.textContent = story.label || '';
      }

      mainVideo.preload = 'auto';
      mainVideo.src = story.videoUrl;
      mainVideo.currentTime = 0;
      applySound();
      var playPromise = mainVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          state.soundOn = false;
          applySound();
          mainVideo.play().catch(function () {});
        });
      }

      var parsedDuration = parseInt(config.storyDuration, 10);
      var durationSec = Number.isFinite(parsedDuration) ? parsedDuration : 60;
      var durationMs = Math.max(5, durationSec) * 1000;
      stepProgress(durationMs, state.index);
      preloadNext(state.index);
    }

    function refreshStoryCard(story) {
      if (!storyCard) return;

      var product = story && story.product ? story.product : null;
      if (!product || !product.url) {
        storyCard.hidden = true;
        return;
      }

      storyCard.hidden = false;

      var productTitle = product.title || 'Produto';
      var productUrl = product.url || '#';
      var imageUrl = product.featuredImage || '';
      var productPrice = Number(product.price || 0);

      storyCardLinks.forEach(function (link) {
        link.setAttribute('href', productUrl);
        link.setAttribute('aria-label', 'Confira ' + productTitle);
      });

      if (storyCardName) {
        storyCardName.textContent = productTitle;
      }


      if (storyCardInstallment) {
        storyCardInstallment.textContent = formatMoney(Math.round(productPrice / 5));
      }

      if (storyCardImage) {
        if (imageUrl) {
          storyCardImage.src = imageUrl;
          storyCardImage.alt = productTitle;
          storyCardImage.hidden = false;
        } else {
          storyCardImage.hidden = true;
        }
      }

      if (storyCardPrice) {
        storyCardPrice.textContent = formatMoney(productPrice);
      }

      var compareAt = getStoryCompareAtPrice(product, productPrice);
      var emPromocao = compareAt > productPrice;

      if (storyCardCompare) {
        storyCardCompare.hidden = !emPromocao;
        storyCardCompare.textContent = emPromocao ? formatMoney(compareAt) : '';
      }

      if (storyCardDiscount) {
        if (emPromocao) {
          storyCardDiscount.hidden = false;
          storyCardDiscount.textContent = '-' + Math.round(((compareAt - productPrice) * 100) / compareAt) + '%';
        } else {
          storyCardDiscount.hidden = true;
          storyCardDiscount.textContent = '';
        }
      }
    }

    function nextStory() {
      state.index += 1;
      if (state.index >= stories.length) {
        closeViewer();
        return;
      }
      renderStory();
    }

    function prevStory() {
      state.index -= 1;
      if (state.index < 0) state.index = 0;
      renderStory();
    }

    function getProductState() {
      var story = state.selectedStory;
      if (!story || !story.product || !Array.isArray(story.product.variants)) return null;
      return story.product;
    }

    function availableSizesByColor(product, colorIndex, sizeIndex, colorValue) {
      var variants = product.variants.filter(function (variant) {
        if (!variant.available) return false;
        if (colorIndex < 0) return true;
        return normalize(getVariantValue(variant, colorIndex)) === normalize(colorValue);
      });

      var sizes = unique(variants.map(function (variant) {
        return getVariantValue(variant, sizeIndex);
      }).filter(Boolean));

      sizes.sort(function (a, b) {
        return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b);
      });

      return sizes;
    }

    function refreshProductCard(product, variant) {
      if (!product) return;

      if (qoTitle) qoTitle.textContent = product.title || 'Produto';
      if (qoProductName) qoProductName.textContent = product.title || 'Produto';

      if (qoImage) {
        var imageSrc = product.featuredImage || '';
        qoImage.src = imageSrc;
        qoImage.alt = product.title || 'Produto';
        qoImage.style.display = imageSrc ? '' : 'none';
      }

      if (qoPrice) {
        var cents = variant && variant.price ? variant.price : product.price;
        qoPrice.textContent = formatMoney(cents || 0);
      }
    }

    function buildQuickOrder() {
      var product = getProductState();
      if (!product) {
        if (qoTitle) qoTitle.textContent = 'Produto nao configurado';
        colorWrap.innerHTML = '';
        sizeWrap.innerHTML = '';
        if (errorEl) {
          errorEl.textContent = 'Selecione um produto no bloco do story para ativar o quick order.';
          errorEl.hidden = false;
        }
        return;
      }

      state.selectedColor = '';
      state.selectedSize = '';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (successEl) successEl.hidden = true;
      if (qtyInput) qtyInput.value = '1';
      colorWrap.innerHTML = '';
      sizeWrap.innerHTML = '';

      var colorIndex = findOptionIndex(product, ['Cor', 'Color']);
      var sizeIndex = findOptionIndex(product, ['Tamanho', 'Size']);

      var colors = unique(product.variants.filter(function (variant) {
        return !!variant.available;
      }).map(function (variant) {
        return getVariantValue(variant, colorIndex);
      }).filter(Boolean));

      colors.forEach(function (color, idx) {
        var btn = createSwatchButton(color);
        if (idx === 0) {
          btn.classList.add('is-active');
          state.selectedColor = color;
        }
        btn.addEventListener('click', function () {
          colorWrap.querySelectorAll('.vs-swatch').forEach(function (el) { el.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.selectedColor = color;
          renderSizes();
        });
        colorWrap.appendChild(btn);
      });

      function renderSizes() {
        sizeWrap.innerHTML = '';

        var sizes = availableSizesByColor(product, colorIndex, sizeIndex, state.selectedColor);
        if (!sizes.length) {
          SIZE_ORDER.forEach(function (size) {
            var btn = createSizeButton(size);
            btn.disabled = true;
            sizeWrap.appendChild(btn);
          });
          return;
        }

        sizes.forEach(function (size, idx) {
          var btn = createSizeButton(size);
          if (idx === 0) {
            btn.classList.add('is-active');
            state.selectedSize = size;
          }
          btn.addEventListener('click', function () {
            sizeWrap.querySelectorAll('.vs-size-pill').forEach(function (el) { el.classList.remove('is-active'); });
            btn.classList.add('is-active');
            state.selectedSize = size;
            var selectedVariant = resolveVariant(product, state.selectedColor, state.selectedSize);
            refreshProductCard(product, selectedVariant);
          });
          sizeWrap.appendChild(btn);
        });
      }

      renderSizes();
      refreshProductCard(product, resolveVariant(product, state.selectedColor, state.selectedSize));
    }

    function openQuickOrder() {
      buildQuickOrder();
      qo.hidden = false;
      qo.setAttribute('aria-hidden', 'false');
    }

    function closeQuickOrder() {
      qo.hidden = true;
      qo.setAttribute('aria-hidden', 'true');
    }

    function resolveVariant(product, color, size) {
      var colorIndex = findOptionIndex(product, ['Cor', 'Color']);
      var sizeIndex = findOptionIndex(product, ['Tamanho', 'Size']);
      return product.variants.find(function (variant) {
        if (!variant.available) return false;
        var variantColor = getVariantValue(variant, colorIndex);
        var variantSize = getVariantValue(variant, sizeIndex);
        return normalize(variantColor) === normalize(color) && normalize(variantSize) === normalize(size);
      });
    }

    function addToCart() {
      var product = getProductState();
      if (!product) {
        if (errorEl) {
          errorEl.textContent = 'Produto nao configurado para este story.';
          errorEl.hidden = false;
        }
        return;
      }

      if (!state.selectedColor || !state.selectedSize) {
        if (errorEl) {
          errorEl.textContent = 'Selecione cor e tamanho.';
          errorEl.hidden = false;
        }
        return;
      }

      var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
      if (Number.isNaN(qty) || qty < 1 || qty > 10) {
        if (errorEl) {
          errorEl.textContent = 'Quantidade deve ser entre 1 e 10.';
          errorEl.hidden = false;
        }
        return;
      }

      var variant = resolveVariant(product, state.selectedColor, state.selectedSize);
      if (!variant) {
        if (errorEl) {
          errorEl.textContent = 'Combinacao indisponivel.';
          errorEl.hidden = false;
        }
        return;
      }

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variant.id, 10),
          quantity: qty
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Erro ao adicionar');
          return response.json();
        })
        .then(function () {
          if (successEl) successEl.hidden = false;
          window.setTimeout(function () {
            closeQuickOrder();
            openCartDrawerFromTheme();
          }, 700);
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = 'Nao foi possivel adicionar ao carrinho.';
            errorEl.hidden = false;
          }
        });
    }

    widget.querySelectorAll('[data-vs-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.storyIndex || '0', 10);
        openViewer(Number.isNaN(idx) ? 0 : idx);
      });
    });

    widget.querySelectorAll('[data-vs-close]').forEach(function (btn) {
      btn.addEventListener('click', closeViewer);
    });

    var prevBtn = widget.querySelector('[data-vs-prev]');
    var nextBtn = widget.querySelector('[data-vs-next]');
    if (prevBtn) prevBtn.addEventListener('click', prevStory);
    if (nextBtn) nextBtn.addEventListener('click', nextStory);

    var openQoBtn = widget.querySelector('[data-vs-open-quick-order]');
    if (openQoBtn) {
      openQoBtn.textContent = 'Adicionar ao Carrinho';
    }
    if (openQoBtn) openQoBtn.addEventListener('click', openQuickOrder);

    widget.querySelectorAll('[data-vs-close-quick-order]').forEach(function (btn) {
      btn.addEventListener('click', closeQuickOrder);
    });

    var qoConfirm = widget.querySelector('[data-vs-confirm-add]');
    if (qoConfirm) qoConfirm.addEventListener('click', addToCart);

    var decBtn = widget.querySelector('[data-vs-qty-dec]');
    var incBtn = widget.querySelector('[data-vs-qty-inc]');

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        var val = parseInt((qtyInput && qtyInput.value) || '1', 10);
        val = Number.isNaN(val) ? 1 : val;
        qtyInput.value = String(Math.max(1, val - 1));
      });
    }

    if (incBtn) {
      incBtn.addEventListener('click', function () {
        var val = parseInt((qtyInput && qtyInput.value) || '1', 10);
        val = Number.isNaN(val) ? 1 : val;
        qtyInput.value = String(Math.min(10, val + 1));
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value || '1', 10);
        if (Number.isNaN(val)) val = 1;
        qtyInput.value = String(Math.min(10, Math.max(1, val)));
      });
    }

    var touchStartX = 0;
    var touchEndX = 0;
    var stage = widget.querySelector('[data-vs-stage]');
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var delta = touchStartX - touchEndX;
        if (Math.abs(delta) < 30) return;
        if (delta > 0) nextStory();
        else prevStory();
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') closeViewer();
      if (e.key === 'ArrowRight') nextStory();
      if (e.key === 'ArrowLeft') prevStory();
    });

  }

  function boot() {
    var widgets = document.querySelectorAll('[data-vs-widget]');
    if (!widgets.length) return;
    widgets.forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
